import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const FormsIFrameDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "uno-formsiframedialogcontainer" */ "./FormsIFrameDialogContainer")).then((bundle)=>{
        return {
            default: bundle.FormsIFrameContainer
        };
    });
export const LazyFormsIFrameDialogContainer = /*#__PURE__*/ lazy(FormsIFrameDialogContainerLazyLoader);
